import { defineAction } from '~/prix'
import { z } from 'zod'
import incentiveDocumentFetchAction from './incentiveDocumentFetch.action.json' with { type: 'json' }
import { incentiveDocumentObject } from '../incentiveDocumentObject'

const incentiveDocumentFetchDefinition = defineAction({
  ...incentiveDocumentFetchAction,

  input: z.object({
    id: incentiveDocumentObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: incentiveDocumentObject,
})

export default incentiveDocumentFetchDefinition
